// extracted by mini-css-extract-plugin
module.exports = {"faq":"mmOfB","readMore":"d3jZy"};